export const SHOP_TITLE = process.env.VSF_SHOP_TITLE;
export const SHOP_EMAIL = process.env.VSF_SHOP_EMAIL;
export const STORE_URL = process.env.VSF_STORE_URL;
export const SHOP_PHONE = process.env.VSF_SHOP_PHONE;
export const SHOP_DESCRIPTION = 'Oficjalny Sklep Producenta Biostymulatorów i Mieszanek Paszowych Uzupełniających - Extracts.Pro';
